const app = {
  state: {
    inWX: false, // 当前所在的环境
    isPC: false, // PC端
    isIos: false, // Ios
    isAndroid: false // Android
  },
  mutations: {
    SET_WX_VALUE: (state, data) => {
      state.inWX = data
    },
    SET_PC_VALUE: (state, data) => {
      state.isPC = data
    },
    SET_IOS_VALUE: (state, data) => {
      state.isIos = data
    },
    SET_ANDROID_VALUE: (state, data) => {
      state.isAndroid = data
    }
  },
  actions: {}
}

export default app
